export default {
  namespaced: true,
  state: {
    temp: [],
  },
  getters: {
    getTemp(state) {
      return state.temp
    },
  },
  mutations: {
    setTemp(state, temp) {
      state.temp.push(temp)
    },
    resetTemp(state) {
      state.temp = []
    },
  },
  actions: {
    async setTemp({ commit }, temp) {
      commit('setTemp', temp)
    },
    async resetTemp({ commit }) {
      commit('resetTemp')
    },
  },
}
